import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Calendar } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import type { DashboardDateBarProps } from "./DashboardDateBar.types";
import * as styles from "./DashboardDateBar.styles";

export type { DashboardDateBarProps } from "./DashboardDateBar.types";

export const DashboardDateBar = memo(function DashboardDateBar({ date }: DashboardDateBarProps) {
  const { t } = useTranslation("home");
  const theme = useTheme();

  return (
    <Box sx={styles.root}>
      <Calendar size={20} variant="Linear" color={theme.palette.primary.main} />
      <Typography variant="body2" sx={styles.label}>
        {t("dashboard.dateLabel")}
      </Typography>
      <Typography variant="body2" sx={styles.value}>
        {date}
      </Typography>
    </Box>
  );
});
